const PAYPAL_ACCOUNT = process.env.MIX_PAYPAL_ACCOUNT;
const PAYPAL_CLIENT_ID = process.env.MIX_PAYPAL_CLIENT_ID;
const PAYPAL_SECRET_ID = process.env.MIX_PAYPAL_SECRET_ID;

export { PAYPAL_ACCOUNT, PAYPAL_CLIENT_ID, PAYPAL_SECRET_ID };
